import { useCallback, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { useTranslation } from "react-i18next";

import { useRootSelector } from "../../../store/hooks";
import { useReload } from "../../../hooks/useReload";
import { useAssets } from "../../../hooks/useAssets";

import { UserDropdown } from "./user-dropdown/UserDropdown";
import { Dialog } from "../../common/dialog/Dialog";

import classes from "./Navigation.module.scss";
import { BannerNotifications } from "components/common/notification/BannerNotifications";
import { isQuickPayRoute } from "utility";

export const Navigation = () => {
  const { isAuthenticated } = useAuth0();
  const { t } = useTranslation(["app"]);
  const location = useLocation();
  const [openDialog, setOpenDialog] = useState(false);
  const { createAssetUrl } = useAssets();
  const { applicationName, client } = useRootSelector((state) => state.config);

  useReload();

  const navigate = useNavigate();

  const isOnQuickPayRoute = isQuickPayRoute(location.pathname);

  const backToHome = () => {
    if (location.pathname.search("/quick-payment") !== -1) {
      setOpenDialog(true);
      return;
    }
    dialogAction();
  };

  const dialogHandler = useCallback((close: boolean) => {
    setOpenDialog(close);
  }, []);

  const dialogAction = () => {
    if (isAuthenticated) {
      navigate(`/${client.customerKey}/dashboard`);
    } else {
      navigate(`/${client.customerKey}`);
    }
  };

  const titleClass = [classes.Nav_title];
  if (isAuthenticated) {
    titleClass.push(classes.Nav_title_shift);
  }

  return (
    <ft-nav centerTitle class={classes.Nav}>
      <div
        aria-label="Header"
        onClick={backToHome}
        className={titleClass.join(" ")}
        slot="navigationIcon"
      >
        <img
          className={classes.Logo}
          src={createAssetUrl("logo")}
          alt={`${applicationName} logo`}
        />
      </div>
      <div
        aria-hidden="true"
        role="presentation"
        onClick={backToHome}
        className={classes.Nav_title_mobile}
        slot="navigationIcon"
      >
        <img
          className={classes.Logo}
          src={createAssetUrl("logo-b")}
          alt={`${applicationName} logo mobile`}
        />
      </div>
      <div slot="title" className={classes.Nav_title_text}>
        <h1 aria-label="Header" className={classes.AppName}>
          {applicationName}
        </h1>
      </div>

      {isAuthenticated && !isOnQuickPayRoute ? (
        <div className={classes.Nav_actionItem} slot="actionItems">
          <UserDropdown />
        </div>
      ) : null}
      <BannerNotifications />
      {openDialog ? (
        <Dialog
          icon="warning_amber"
          dialogClosed={dialogHandler}
          primaryActionLabel={t("app:reload_label")}
          primaryActionHandler={dialogAction}
          type="warning"
        >
          {t("app:reload_site")}
        </Dialog>
      ) : null}
    </ft-nav>
  );
};
